/* eslint-disable max-lines-per-function */
import React from "react";
import { Grid } from "@mui/material";
import Settings from "settings";
import { Column } from "components/common/html";
import { Input as InputWithLabel } from "components/haven-design/form/inputs";
import CalendlyPopup from "./calendly-popup";
import styles from "./demo.module.css";

type Props = {};

const DemoPage: React.FC<Props> = () => {
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const calendlyOpts =
    "primary_color=2EB6C8&" +
    `first_name=${firstName}&` +
    `last_name=${lastName}&` +
    `email=${email}&` +
    `a1=+1${phone}`;

  return (
    <div className={`container ${styles.demoContainer}`}>
      <h1>
        Schedule a <span className="color-primary">30 minute demo</span> with a waitlist management
        specialist.
      </h1>

      <p className={styles.desc}>
        We&apos;ll walk you through our product dashboard features,
        and help with any questions you might have.
      </p>

      <p className={styles.disclaimer}>
        <i>
          If you&apos;re an applicant looking for affordable housing, please{" "}
          <a href={Settings.whitelabel_server_url} target="_blank" rel="noreferrer">
            review our open waitlists
          </a>
          .
        </i>
      </p>

      <Grid container size={{ xs: 12 }} spacing={2} style={{ maxWidth: 600 }}>
        <Column width={6}>
          <InputWithLabel
            name="name"
            label="First Name"
            type="text"
            onChange={({ target: { value } }) => setFirstName(value)}
          />
        </Column>

        <Column width={6}>
          <InputWithLabel
            name="name"
            label="Last Name"
            type="text"
            onChange={({ target: { value } }) => setLastName(value)}
          />
        </Column>

        <Column width={6}>
          <InputWithLabel
            name="email"
            label="Work Email Address"
            type="email"
            onChange={({ target: { value } }) => setEmail(value)}
          />
        </Column>

        <Column width={6}>
          <InputWithLabel
            name="phone"
            label="Phone Number"
            type="text"
            onChange={({ target: { value } }) => setPhone(value)}
          />
        </Column>
      </Grid>

      <CalendlyPopup
        buttonText="Schedule Meeting"
        url="https://calendly.com/jenny-204/20-minute-phone-call"
        options={calendlyOpts}
      />
    </div>
  );
};

export default DemoPage;
